import apollo from 'graphql/apollo';
import { updateProfileMutation } from 'graphql/mutations';

const updateProfile = async ({ salutation, firstName, lastName, position, phone }) =>
  apollo.mutate({
    mutation: updateProfileMutation,
    variables: { profile: { salutation, firstName, lastName, position, phone } },
  });
export default updateProfile;
